import type * as Types from '~/gql/graphql';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserFieldsFragment = { id: string, full_name?: string | null, user_avatar?: { public_url: string } | null, active_org?: { org: { id: string, name: string, org_avatar?: { public_url: string } | null } } | null };

export type GetUsersQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetUsersQuery = { project?: { id: string, members: Array<{ role: { name: string }, user: { id: string, full_name?: string | null, user_avatar?: { public_url: string } | null, active_org?: { org: { id: string, name: string, org_avatar?: { public_url: string } | null } } | null } }> } | null };

export type GetTeamsQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetTeamsQuery = { project?: { id: string, teams: Array<{ id: string, name: string, color: string }> } | null };

export const UserFieldsFragmentDoc = gql`
    fragment UserFields on users {
  id
  full_name
  user_avatar {
    public_url
  }
  active_org {
    org {
      id
      name
      org_avatar {
        public_url
      }
    }
  }
}
    `;
export const GetUsersDocument = gql`
    query getUsers($id: uuid!) {
  project: projects_by_pk(id: $id) {
    id
    members {
      role {
        name
      }
      user {
        ...UserFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

export function useGetUsersQuery(options: Omit<Urql.UseQueryArgs<GetUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersQuery, GetUsersQueryVariables>({ query: GetUsersDocument, ...options });
};
export const GetTeamsDocument = gql`
    query getTeams($id: uuid!) {
  project: projects_by_pk(id: $id) {
    id
    teams {
      id
      name
      color
    }
  }
}
    `;

export function useGetTeamsQuery(options: Omit<Urql.UseQueryArgs<GetTeamsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTeamsQuery, GetTeamsQueryVariables>({ query: GetTeamsDocument, ...options });
};